export enum Visibility {
	PUBLIC = "public",
	UNLISTED = "unlisted",
	PRIVATE = "private",
}

export const visibilities = ["public", "unlisted", "private"] as const;
